import { createContext, useContext } from 'react';
import type { AppData } from '@/types/app';

export const AppDataContext = createContext<AppData | null>(null);

export function useAppData(): AppData | null {
  return useContext(AppDataContext);
}
